import { useMutation, UseMutationOptions, UseMutationResult, useQuery, UseQueryResult } from "react-query";
import { request, gql, ClientError, GraphQLClient } from "graphql-request";
import { apiBaseUrl, graphQLClient, __DEV__ } from "../api";
import moment from "moment";

export interface BundleParams {
  country?: string;
  language?: string;
  currency?: string;
  limit?: number;
}

export function useBundles(
  params?: BundleParams,
  onSuccessCustom?: (data: [GQL.V2Bundle]) => void
): UseQueryResult<[GQL.V2Bundle], ClientError> {
  const { country, language, currency, limit = 500 } = params || {};

  return useQuery(
    ["v2Bundles", country, language, currency, limit],
    async () => {
      const { v2Bundles: data } = await graphQLClient.request(
        gql`
          query v2Bundles($country: String, $language: String, $currency: String, $limit: Int) {
            v2Bundles(country: $country, language: $language, currency: $currency, limit: $limit) {
              bundleId
              name
              image
              products
              locales
              index
              bundleTags
              tags
              isCrossedPriceVisible
              note
              relatedCartCrossSellBundles
              productDetailPageGroup
              translations {
                description
                nameOrder
                nameMarketing
                images
                labels
                relatedCartCrossSellBundles
                productDetailPageGroup
              }
              prices {
                stripePriceIds
                stripePriceIdsExtended
                priceAmountPayNowCurrent
                priceAmountPayNowCrossed
                priceAmountPayAfterTrialCurrent
                priceAmountPayAfterTrialCrossed
                priceAmountOneTimeCurrent
                priceAmountOneTimeCrossed
                priceAmountRecurringCurrent
                priceAmountRecurringCrossed
                recurringInterval
                recurringIntervalCount
                recurringTrialPeriodDays
                savings
              }
              productsExtended {
                productId
                name
                image
                defaultPriceAmount
                prices {
                  priceAmountPayNowCurrent
                }
              }
            }
          }
        `,
        { limit }
      );
      if (__DEV__) {
        console.log("Bundles data:", data);
      }
      return data;
    },
    {
      onSuccess: (data: any) => {
        if (onSuccessCustom !== undefined) onSuccessCustom!(data);
      },
      // Don't refetch when window gets focus if we already have data
      refetchOnWindowFocus: false,
      // Keep previous data while fetching new data
      keepPreviousData: true,
    }
  );
}
